import React, { useEffect } from 'react';
import { useState } from 'react';
import useGetStartedActionsContext from 'contexts/get-started-actions.context';
import { FileDetailsType } from './add-csv-file';
import { Input, Switch } from '@cokitchen/cokitchen-components';
import 'pages/events/event-details/styles.scss';
import SelectDropdown from 'components/base/select-dropdown';
import CurrencyInput from 'components/base/currency-input';
import BirthdayInput from 'components/base/birthday-input';
import { toTitleCase } from 'utils/functions';
import { DepartmentType } from 'models/department.model';

type AddNewTeamProps = {
  teamData: FileDetailsType;
  setTeamData: (teamData: FileDetailsType) => void;
  className?: string;
  showRemoveButton: boolean;
  index: number;
  departmentOptions: DepartmentType[];
  department: DepartmentType | undefined;
};

const budgetDurationOptions = [
  { name: 'Daily', id: 'Daily' },
  { name: 'Weekly', id: 'Weekly' },
  { name: 'Monthly', id: 'Monthly' }
];
const budgetSettingOptions = [
  // { name: 'One Off', id: 'ONE OFF' },
  { name: 'Roll Over', id: 'ROLL OVER' },
  { name: 'Recurring', id: 'RECURRING' }
];

const AddTeamForm = (props: AddNewTeamProps) => {
  const { teamData, index, setTeamData, department, departmentOptions } = props;
  const { teamDataForm, setTeamDataForm } = useGetStartedActionsContext();

  const [selectedDepartment, setSelectedDepartment] = useState<DepartmentType | undefined>(
    department || undefined
  );
  const [selectedBudgetDuration, setSelectedBudgetDuration] = useState('');

  useEffect(() => {
    setTeamData({ ...teamData, department: selectedDepartment?.name });
  }, [selectedDepartment]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { target } = e;
    const { name, value } = target;
    setTeamData({
      ...teamData,
      [name]: value
    });
  };

  const handleSwitch = () => {
    teamData.role === 'ADMIN'
      ? setTeamData({ ...teamData, role: 'MEMBER' })
      : setTeamData({ ...teamData, role: 'ADMIN' });
  };
  const handleDelete = () => {
    setTeamDataForm(teamDataForm.filter((_, i) => i !== index));
  };

  const handleSelectDate = (date: Date | undefined) => {
    if (!date) return;
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + 1);
    const updatedTeamDataForm = { ...teamData };
    updatedTeamDataForm.dob = newDate.toISOString().split('T')[0];
    setTeamData(updatedTeamDataForm);
  };
  useEffect(() => {
    setTeamData({
      ...teamData,
      department: selectedDepartment?.name || '',
      budget_duration: selectedBudgetDuration
    });
  }, [selectedBudgetDuration, selectedDepartment]);
  useEffect(() => {
    setTeamData({
      ...teamData,
      department: selectedDepartment?.name || '',
      budget_duration: selectedBudgetDuration
    });
  }, []);
  useEffect(() => {
    setSelectedBudgetDuration(teamData.budget_duration ?? '');
  }, []);
  return (
    <div className='max-w-[396px] text-sm space-y-4 border-b border-[#E9EAEC] py-4'>
      {index > 0 && (
        <div
          onClick={handleDelete}
          className='text-[#E60A2B] text-sm my-2 cursor-pointer ml-5 flex justify-end gap-1'>
          - <span>Remove member</span>
        </div>
      )}
      <div className='flex gap-2 flex-wrap w-full justify-between mb-[28px]'>
        <div className='w-full sm:w-[48%]'>
          <Input
            design='bordered'
            type='text'
            label='First name'
            name='first_name'
            value={teamData?.first_name}
            onChange={handleChange}
            placeholder='Donatus'
          />
        </div>
        <div className='w-full sm:w-[48%]'>
          <Input
            design='bordered'
            type='text'
            label='Last name'
            name='last_name'
            value={teamData?.last_name}
            onChange={handleChange}
            placeholder='Globus'
          />
        </div>
      </div>
      <Input
        design='bordered'
        type='phone'
        label='Mobile Number'
        name='phone_number'
        value={teamData?.phone_number}
        onChange={handleChange}
        placeholder='07018135214'
        className='mb-3'
      />
      <Input
        design='bordered'
        type='email'
        label='Email'
        name='email'
        value={teamData?.email}
        onChange={handleChange}
        placeholder='donatusglobus13@gmail.com'
        className='mb-3'
      />

      <BirthdayInput value={teamData.dob} handleSelectDate={handleSelectDate} />

      <SelectDropdown
        label='Department'
        value={selectedDepartment?.name}
        setValue={setSelectedDepartment}
        placeholder='Select a department'
        options={departmentOptions}
      />

      <div className='flex gap-2 flex-wrap w-full justify-between'>
        <div className='w-full sm:w-[48%]'>
          <CurrencyInput
            label='Set a budget'
            value={teamData.budget}
            name='budget'
            onChange={(budget) => {
              setTeamData({
                ...teamData,
                budget
              });
            }}
            placeholder='50,000'
          />
        </div>

        <div className='w-full sm:w-[48%] mt-[-8px]'>
          <SelectDropdown
            value={selectedBudgetDuration}
            setValue={(option) => setSelectedBudgetDuration(option.name)}
            placeholder='Daily'
            options={budgetDurationOptions}
            label='Budget Duration'
          />
        </div>
      </div>
      <SelectDropdown
        value={toTitleCase(teamData?.budget_setting)}
        setValue={(option) =>
          setTeamData({
            ...teamData,
            budget_setting: option.id
          })
        }
        placeholder='Select Budget Setting'
        options={budgetSettingOptions}
        label='Budget Setting'
      />
      <p className='text-xs text-[#96999C]'>All fields are required*</p>
      <div className='flex gap-4'>
        <div className=''>
          <p className='text-[16px] font-semibold'>Assign this person as an admin</p>
          <p className='text-[#6F7376] text-sm'>
            The designated employee must accept this role via email
          </p>
        </div>
        <Switch active={teamData.role === 'ADMIN'} onChange={handleSwitch} />
      </div>
    </div>
  );
};

export default AddTeamForm;
